import { COLORS } from "../../../common/constants";
import { FontFamily } from "../../../common/utils";

const styles = {
  btnPrimary: {
    textTransform: "capitalize",
    cursor: "pointer",
    borderRadius: "0",
    background: `linear-gradient(30.99deg, ${COLORS.primaryBlue} 0%, ${COLORS.lightBlue} 100%)`,
    font: FontFamily(500, 20, 22),
    letterSpacing: "0.59px",
    boxShadow: `0px 10px 14px rgba(0, 0, 0, 0.15)`,
    fontWeight: "600",
    "&.MuiButtonBase-root": {
      fontFamily: "mreavesxlsanot-reg",
      color: `${COLORS.white} !important`,
      fontWeight: "600 !important",
      "&:hover": {
        background: `linear-gradient(30.99deg, ${COLORS.primaryBlue} 0%, ${COLORS.lightBlue} 100%)`,
        color: COLORS.white,
      },
      "&:disabled": {
        background: "#F3F3F3",
        color: "rgba(24, 27, 32, 0.87) !important",
        backdropFilter: "blur(20px)",
        boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.15)",
      },
    },
  },
  btnNormal: {
    textTransform: "capitalize",
    cursor: "pointer",
    borderRadius: "0",
  },
};
export default styles;
